import { Box, Card, Tabs, Tab,  } from '@mui/material'
import React, { useState } from 'react'
import ServiceTable from './ServiceTable';
import MissingServicesList from './MissingServicesList';

const ServiceList = () => {
    const [tabValue, setTabValue] = useState('0');
    const handleChange = (event, newValue) => {
      setTabValue(newValue);
    }
  return (
    <>
      <Card sx={{ minWidth: "100%", marginBottom: ".25%" }}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            sx={{ p: 0, minHeight: '40px' }}
            variant="scrollable"
            scrollButtons="auto"
          >

            <Tab value="0" label="Selected " sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
            <Tab value="1" label="Missing" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
            {/* <Tab value="three" label="Item Three" /> */}
          </Tabs>
        </Box>
      </Card>
      {tabValue === '0' && <ServiceTable />}
      {tabValue === '1' && <MissingServicesList />}
    </>
  )
}

export default ServiceList
